import type { RouteRecordRaw } from 'vue-router';

import NavigationRailView from '@/services/router/views/NavigationRailView.vue';
import DashboardView from '@/flow/flow/views/DashboardView.vue';
import FlowEdit from '@/flow/flow/views/FlowEdit.vue';
import FlowCreatedView from '@/flow/flow/views/FlowCreatedView.vue';
import FlowDeleteView from '@/flow/flow/views/FlowDeleteView.vue';
import PageView from '@/flow/flow/views/PageView.vue';

const routes: RouteRecordRaw[] = [
    {
        path: '/dashboard',
        name: 'flow-dashboard',
        redirect: { name: 'assistent-dashboard' },
        components: {
            default: DashboardView,
            rail: NavigationRailView,
        },
        children: [
            {
                path: 'flow/:flowId/verwijderen',
                name: 'flow-delete',
                components: {
                    default: FlowDeleteView,
                },
            },
        ],
    },
    {
        path: '/flow/:flowId',
        name: 'edit-flow',
        props: true,
        components: {
            default: FlowEdit,
        },
        children: [
            {
                path: 'created',
                name: 'edit-flow-created',
                props: true,
                components: {
                    default: FlowCreatedView,
                },
            },
        ],
    },
    {
        path: '/page/:pageId',
        name: 'page',
        props: true,
        components: {
            default: PageView,
        },
        meta: {
            anonymous: true,
        },
    },
];

export default routes;
